import Reflux from "reflux";

const SiteSettingsActions = Reflux.createActions([
  "changeTab",
  "changeView",
  "openDialog",
  "openDialogWithSection",
  "closeDialog",
  "toggleSubdomainAdd",
  "addSubdomain",
  "saveSettings",
  "updateProperty",
]);

export default SiteSettingsActions;
